import { parseTrustBudDate } from "../../shared/utils/trustbudDates";

export function formatWeekRange(start, end) {
  if (!start || !end) return "";
  const startDate = parseTrustBudDate(start);
  const endDate = parseTrustBudDate(end);
  if (!startDate || !endDate) return "";
  const startLabel = startDate.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
  const endLabel = endDate.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
  return `${startLabel} - ${endLabel}`;
}

function getComparisonText(item, fallback = "This week") {
  return item?.context || fallback;
}

export function buildWeeklySummaryModel(summary) {
  const summaryData = summary?.summary_data || {};
  const overview = summaryData.overview || {};
  const comparisons = overview.comparisons || {};
  const highlights = Array.isArray(summaryData.highlights) ? summaryData.highlights : [];
  const plusLearning = summaryData.plus_learning || {};
  const appliedChanges = Array.isArray(plusLearning.changes)
    ? plusLearning.changes.slice(0, 3)
    : Array.isArray(summaryData.applied_intelligence_changes)
      ? summaryData.applied_intelligence_changes.slice(0, 3)
      : [];
  const keyActions = Array.isArray(summaryData.key_actions) ? summaryData.key_actions.slice(0, 5) : [];
  const circleActivity = summaryData.circle_activity || null;
  const lookingAhead = summaryData.looking_ahead || {
    title: "Plan next week",
    body: "Pick one thing to focus on next.",
    cta_label: "Plan next week",
  };

  return {
    weekLabel: formatWeekRange(summary?.week_start_date, summary?.week_end_date),
    reinforcement:
      summaryData.reinforcement_message ||
      (overview.actions_completed > 0 ? "You stayed in it this week." : "Quiet week. Start the next one with one clear step."),
    stats: [
      {
        key: "actions",
        label: "Habits completed",
        value: overview.actions_completed ?? 0,
        context: getComparisonText(comparisons.actions_completed),
      },
      {
        key: "days",
        label: "Days active",
        value: overview.active_days ?? 0,
        context: getComparisonText(comparisons.active_days),
      },
      {
        key: "checkins",
        label: "Check-ins",
        value: overview.checkins ?? summaryData.check_in_count ?? 0,
        context: getComparisonText(comparisons.checkins),
      },
      {
        key: "followThrough",
        label: "Follow-through",
        value: `${overview.follow_through_percent ?? 0}%`,
        context: getComparisonText(comparisons.follow_through_percent),
      },
    ],
    highlights,
    plusLearning: {
      title: plusLearning.title || "What Plus is learning",
      body:
        plusLearning.body ||
        "TrustBud checks whether each recommendation helped, then uses that result to adjust future support.",
      changes: appliedChanges,
    },
    appliedChanges,
    keyActions,
    circleActivity,
    lookingAhead,
  };
}
